import {LastActivityDate} from '@hconnect/apiclient'
import {Button, Modal, ModalContent, ModalFooter, ModalTitle} from '@hm/fundamental'

import {useTranslation} from '../../../../hooks/useTranslation'
import {ProductActivity} from '../../ProductActivity/ProductActivity'

type ProductActivityDialogProps = {
  open: boolean
  setOpenModal: (open: boolean) => void
  isLoading: boolean
  lastActivityDates?: LastActivityDate[]
}
export const ProductActivityDialog = ({
  open,
  setOpenModal,
  isLoading,
  lastActivityDates
}: ProductActivityDialogProps) => {
  const {t} = useTranslation()

  return (
    <Modal open={open} onClose={() => setOpenModal(false)}>
      <ModalTitle>{t('userInformationForm.productActivity')}</ModalTitle>
      <ModalContent>
        <ProductActivity lastActivityDates={lastActivityDates} isLoading={isLoading} />
      </ModalContent>
      <ModalFooter>
        <Button size="large" variant="secondary" onClick={() => setOpenModal(false)}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  )
}
